import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';


@Component({
    selector: 'cu-download-link-cell-renderer',
    // template: `
    //   <button title="Edit" (click)="Edit()">Edit</button>&nbsp;
    //   <button title="Delete" (click)="Delete()">Delete</button>&nbsp;
    // `
    template: require('./strategyCellRenderer.html'),
    styles: [require('./renderersStyles.css')]
  })
  export class strategyCellRendererComponent{
  
      params:any;
  
      constructor() {
      }
  
      agInit(params:any): void { 
          this.params = params;
     }
  
     Edit(): void {
         this.params.edit(this.params);
     }

     Delete(): void {
      this.params.delete(this.params);
  }

     Load(): void {
        this.params.load(this.params);
    }

    Save(): void {
        this.params.save(this.params);
    }

    get isChallengeAccount():boolean
    {
        if(this.params.workspaceService!==undefined)
        {
             return (this.params.workspaceService.data.competitionAccountList.indexOf(this.params.data.id) > -1)
        }
        else
        {
            return false;
        }
    }
  }
  
  export type CellAction = (params:any) => void;